export const GETTERS_CLIENT_BRAND = "GETTERS_CLIENT_BRAND";

export const ACTION_GET_CLIENT_BRAND_BY_CLIENT =
  "ACTION_GET_CLIENT_BRAND_BY_CLIENT";
export const ACTION_UPDATE_CLIENT_BRAND = "ACTION_UPDATE_CLIENT_BRAND";
export const ACTION_CREATE_CLIENT_BRAND = "ACTION_CREATE_CLIENT_BRAND";

export const MUTATION_SET_CLIENT_BRAND = "MUTATION_SET_CLIENT_BRAND";
export const MUTATION_RESET_CLIENT_BRAND = "MUTATION_RESET_CLIENT_BRAND";



// WEBPACK FOOTER //
// ./src/store/modules/client_brand/constants.js